/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs */

const en_admin_dashboard_empty_state_invoices_setup_invoices = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up invoices`)
};

const de_admin_dashboard_empty_state_invoices_setup_invoices = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungen hinzufügen`)
};

const es_admin_dashboard_empty_state_invoices_setup_invoices = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir facturas`)
};

const fr_admin_dashboard_empty_state_invoices_setup_invoices = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter des factures`)
};

const nl_admin_dashboard_empty_state_invoices_setup_invoices = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturen instellen`)
};

const it_admin_dashboard_empty_state_invoices_setup_invoices = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura fatture`)
};

const pt_br2_admin_dashboard_empty_state_invoices_setup_invoices = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurar faturas`)
};

const pl_admin_dashboard_empty_state_invoices_setup_invoices = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skonfiguruj faktury`)
};

const hu_admin_dashboard_empty_state_invoices_setup_invoices = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Számlák beállítása`)
};

const ro_admin_dashboard_empty_state_invoices_setup_invoices = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurati facturile`)
};

/**
* | output |
* | --- |
* | "Set up invoices" |
*
* @param {Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_empty_state_invoices_setup_invoices = /** @type {((inputs?: Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Empty_State_Invoices_Setup_InvoicesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_empty_state_invoices_setup_invoices(inputs)
	if (locale === "de") return de_admin_dashboard_empty_state_invoices_setup_invoices(inputs)
	if (locale === "es") return es_admin_dashboard_empty_state_invoices_setup_invoices(inputs)
	if (locale === "fr") return fr_admin_dashboard_empty_state_invoices_setup_invoices(inputs)
	if (locale === "nl") return nl_admin_dashboard_empty_state_invoices_setup_invoices(inputs)
	if (locale === "it") return it_admin_dashboard_empty_state_invoices_setup_invoices(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_empty_state_invoices_setup_invoices(inputs)
	if (locale === "pl") return pl_admin_dashboard_empty_state_invoices_setup_invoices(inputs)
	if (locale === "hu") return hu_admin_dashboard_empty_state_invoices_setup_invoices(inputs)
	return ro_admin_dashboard_empty_state_invoices_setup_invoices(inputs)
});
export { admin_dashboard_empty_state_invoices_setup_invoices as "admin.dashboard.empty_state.invoices.setup_invoices" }